// extracted by mini-css-extract-plugin
export default {"editor":"PostPreviewQuillComponent-module__editor--zKAbp"};